import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../../../core/services/api.service';
import { ToastService } from 'angular-toastify';
import { cityParkingVehicleMasterListResponse } from '../../../../../core/models/lineOA.model';
import { CityParkingUserVehiclePayload } from '../../../../../core/models/vehicle.model';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-modal-license-add',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-license-add.component.html',
  styleUrls: ['./modal-license-add.component.css']
})
export class ModalLicenseAddComponent implements OnInit {
  isOpen: boolean = true;
  @Input() vehicleTypeId: number | null = null;
  @Input() cpUserId: number | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();

  plateNumber: string = '';
  provinceId: number | null = null;
  userId: number | null = null;

  masterData: cityParkingVehicleMasterListResponse | null = null;
  isLoading: boolean = false;
  openDropdown: string | null = null;

  constructor(
    private api: ApiService,
    private toast: ToastService,
    private cookieService: CookieService
  ) {


  }

  ngOnInit(): void {
    //console.log('Vehicle Type ID:', this.vehicleTypeId);
    this.fetchMasterData();

    const userIdFromSession = sessionStorage.getItem('user_id');
    this.userId = parseInt(this.cookieService.get('user_id')) || (userIdFromSession ? JSON.parse(userIdFromSession) : 0);
  }

  fetchMasterData() {
    this.api.getVehicleMaster().subscribe({
      next: (res) => {
        this.masterData = res;
      },
      error: (err) => {
        console.error('Error fetching vehicle master data:', err);
        this.toast.error('ไม่สามารถดึงข้อมูลจังหวัดและประเภทรถได้');
      }
    });
  }

  onSave() {
    if (!this.plateNumber || !this.provinceId) {
      this.toast.error('กรุณากรอกข้อมูลให้ครบถ้วน');
      return;
    }

    if (!this.cpUserId) {
      this.toast.error('กรุณาเลือกสมาชิก LINE OA ก่อนเพิ่มทะเบียน');
      return;
    }

    this.isLoading = true;
    const payload: CityParkingUserVehiclePayload = {
      id: 0,
      oldProvince: 0,
      oldlicense: '',
      oldVehicleType: 0,
      plateNumber: this.plateNumber,
      vehicleTypeId: this.vehicleTypeId || 0,
      vehicleStatusId: 2,
      cpUserId: this.cpUserId || 0,
      userId: this.userId || 0,
      provinceId: this.provinceId || 0
    };

    this.api.sentAddVehicle(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        //console.log("Response Add Vehicle : ", res)
        if (res.isSuccess) { // Adjust based on actual response
          this.toast.success(res.message);
          this.save.emit();
          this.closeModal();
        } else {
          this.toast.error(res.message || 'เกิดข้อผิดพลาดในการบันทึก');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error adding vehicle:', err);
        this.toast.error('เกิดข้อผิดพลาดในการบันทึก');
      }
    });
  }

  closeModal() {
    this.plateNumber = '';
    this.provinceId = null;
    this.vehicleTypeId = null;
    this.close.emit();
  }

  /*--------------------------------------- Dropdown Helpers ----------------------------*/
  toggleDropdown(key: string, event: Event) {
    event.stopPropagation();
    if (this.openDropdown === key) {
      this.openDropdown = null;
    } else {
      this.openDropdown = key;
    }
  }

  closeDropdowns() {
    this.openDropdown = null;
  }

  selectOption(key: string, value: any) {
    if (key === 'provinces') {
      this.provinceId = value;
    } else if (key === 'vehicleTypes') {
      this.vehicleTypeId = value;
    }
    this.openDropdown = null;
  }

  getOptionName(key: string, value: any): string {
    if (!value && value !== 0) return '';
    if (key === 'provinces') {
      const p = this.masterData?.cityParkingProvinceListResponses.find(x => x.id === value);
      return p ? p.name : '';
    } else if (key === 'vehicleTypes') {
      const t = this.masterData?.cityParkingVehicleTypeListResponses.find(x => x.id === value);
      return t ? t.name : '';
    }
    return '';
  }

  get provinceOptions() {
    return (this.masterData?.cityParkingProvinceListResponses || []).map(p => ({
      label: p.name,
      value: p.id
    }));
  }

  get vehicleTypeOptions() {
    return (this.masterData?.cityParkingVehicleTypeListResponses || []).map(t => ({
      label: t.name,
      value: t.id
    }));
  }
}
